<div class="content-body" style="height:100%;">
  <div style="position: fixed; right: 0; display: flex; flex-direction: column; align-items: center;margin: 4px 2px;
  z-index: 4;
  gap: 1px;">
    <div class="icon-container" [matMenuTriggerFor]="moreMenu">
      <i class="fa-duotone fa-circle-ellipsis icon"></i>
    </div>
  </div>
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="mat-tiny-tabs" dynamicHeight [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event)">
    <mat-tab label="Redaction">
      <div style="display: flex; flex-direction: column; align-items: center;">
        <lex-redaction-list *ngIf="!isRedactionProcessing" style="width:100%;"></lex-redaction-list>
        <div style="margin-top: 50%" *ngIf="isRedactionProcessing" class="fa-duotone fa-compass-drafting redaction-animation"></div>
      </div>
    </mat-tab>
    <mat-tab label="Annotation">
      <div style="display: flex; flex-direction: column; align-items: center;">
        <lex-annotation-list *ngIf="!isAnnotationProcessing" style="width:100%;"></lex-annotation-list>
        <div style="margin-top: 50%"  *ngIf="isAnnotationProcessing" class="fa-duotone fa-compass-drafting redaction-animation"></div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <mat-menu #moreMenu="matMenu">
    <div *ngIf="tabIndex === 0">
      <button mat-menu-item (click)="openManualRedactionUpload()" [disabled]="hasNativeRedaction">Upload Manual Redaction</button>
      <button mat-menu-item (click)="deleteRedaction()" [disabled]="shouldDisableDeleteRedaction()">Delete Redacted
        Version</button>
      <button mat-menu-item (click)="viewRedactedDocument()" [disabled]="shouldDisableViewRedaction()">View Redacted
        Version</button>
      <button mat-menu-item (click)="openManualNativeRedactionUpload()" [disabled]="hasRedaction || hasManualRedactedPdf">Upload Native
        Redacted
        Version</button>
      <button mat-menu-item (click)="downloadNativeRedactedFile()"
        [disabled]="shouldDisableNativeRedaction()">Download Native
        Redacted
        Version</button>
      <button mat-menu-item (click)="deleteNativeRedaction()" [disabled]="shouldDisableNativeRedaction()">Delete
        Native
        Redacted
        Version</button>
    </div>
    <div *ngIf="tabIndex === 1">
      <button mat-menu-item (click)="openManualAnnotationUpload()">Upload Manual Annotation</button>
      <button mat-menu-item (click)="deleteAnnotation()" [disabled]="shouldDisableDeleteAnnotation()">Delete Annotated
        Version</button>
      <button mat-menu-item (click)="viewAnnotatedDocument()" [disabled]="shouldDisableViewAnnotation()">View Annotated
        Version</button>
    </div>
  </mat-menu>
</div>
